// src/components/Navbar.js
import React, { useEffect } from "react";
import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Drawer,
    List,
    ListItemButton,
    ListItemText,
    Box,
    Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";

const pages = [
    { label: "Home", path: "/" },
    { label: "Why Us", path: "/why-us" },
    { label: "Projects", path: "/projects" },
    { label: "Services", path: "/services" },
    { label: "Paint Budget Calculator", path: "/paintcalculator" },
    { label: "Contact", path: "/contact" },
];

function Navbar() {
    const [mobileOpen, setMobileOpen] = React.useState(false);

    // Admin shortcut
    useEffect(() => {
        const handler = (e) => {
            if (e.ctrlKey && e.shiftKey && e.key === "A") {
                window.location.href = "/admin-login";
            }
        };
        window.addEventListener("keydown", handler);
        return () => window.removeEventListener("keydown", handler);
    }, []);

    return (
        <>
            <AppBar
                position="sticky"
                color="primary"
                elevation={4}
                sx={{
                    px: { xs: 2, sm: 4 },
                }}
            >
                <Toolbar sx={{ justifyContent: "space-between" }}>
                    {/* Logo & Brand */}
                    <Box
                        component={Link}
                        to="/"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            textDecoration: "none",
                            color: "#fff",
                        }}
                    >
                        <Box
                            component="img"
                            src="/assets/pmlogo3.png"
                            alt="PM Enterprise Logo"
                            sx={{ height: 42, width: 42, mr: 1 }}
                        />
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            PM Enterprise
                        </Typography>
                    </Box>

                    {/* Desktop Links */}
                    <Box sx={{ display: { xs: "none", sm: "flex" }, gap: 3 }}>
                        {pages.map((p) => (
                            <Typography
                                key={p.label}
                                component={Link}
                                to={p.path}
                                sx={{
                                    color: "#fff",
                                    textDecoration: "none",
                                    fontWeight: 500,
                                    fontSize: "1rem",
                                    position: "relative",
                                    "&:hover": {
                                        color: "secondary.main",
                                    },
                                }}
                            >
                                {p.label}
                            </Typography>
                        ))}
                    </Box>

                    {/* Mobile Menu Icon */}
                    <IconButton
                        color="inherit"
                        sx={{ display: { sm: "none" } }}
                        onClick={() => setMobileOpen(true)}
                    >
                        <MenuIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>

            {/* Mobile Drawer */}
            <Drawer anchor="right" open={mobileOpen} onClose={() => setMobileOpen(false)}>
                <Box sx={{ width: 240, py: 2 }}>
                    <Box sx={{ px: 2, pb: 1 }}>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            PM Enterprise
                        </Typography>
                        <Divider sx={{ my: 1 }} />
                    </Box>
                    <List>
                        {pages.map((p) => (
                            <ListItemButton
                                key={p.label}
                                component={Link}
                                to={p.path}
                                onClick={() => setMobileOpen(false)}
                            >
                                <ListItemText primary={p.label} primaryTypographyProps={{ fontWeight: 500 }} />
                            </ListItemButton>
                        ))}
                    </List>
                </Box>
            </Drawer>
        </>
    );
}

export default Navbar;
